module.exports = __webpack_public_path__ + "media/images/honesty-1f46965f92cbd31d89ea0b974a8e5d09.png";